import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import { cabinetsProductListConfig } from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import withCategoryFilter from 'rangeConfig/shared/widgets/withCategoryFilter';
import * as R from 'ramda';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import { CoreApi } from '@inter-ikea-storageone/range';
import { getBrorNoMatchingFramesForCabinetsErrorMessage } from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { hideBrorNoMatchingFramesForCabinetErrorMessage } from 'rangeConfig/bror/rules/hideMenuRules';

const InSectionWallMountedSwiper = R.pipe(withCategoryFilter(['cabinets-wall']));
const FloorStandingSwiper = R.pipe(withCategoryFilter(['cabinets-floor']));

const widgets = {
  desktop: [
    {
      id: 'error-message-no-matching-cabinet-dimensions',
      component: withErrorMessage(getBrorNoMatchingFramesForCabinetsErrorMessage)(
        ErrorMessageInline
      ),
      hidden: (coreApi: CoreApi) => hideBrorNoMatchingFramesForCabinetErrorMessage(coreApi)
    },
    {
      id: 'cabinets-product-list',
      component: withProducts(ProductList, cabinetsProductListConfig)
    }
  ],
  mobile: [
    {
      id: 'cabinets-in-section-wall-mounted',
      component: InSectionWallMountedSwiper(withProducts(ProductSwiper, cabinetsProductListConfig)),
      title: 'storageone.addTvSheetChoiceWall'
    },
    {
      id: 'cabinets-floor-standing',
      component: FloorStandingSwiper(withProducts(ProductSwiper, cabinetsProductListConfig)),
      title: 'storageone.productListFreestandingCabinetsTitle'
    }
  ]
};

const filters = {
  desktop: [],
  mobile: []
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListCabinetsTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: filters[platform],
  widgets: widgets[platform]
};

export default mainMenu;
